/* eslint-disable react/prop-types */
import React, {useRef } from 'react';
import { DragSource, DropTarget, useDrag, useDrop, } from 'react-dnd';

let dragingIndex = -1;

const type = 'DraggableBodyRow';

class BodyRow extends React.Component {
  render() {
    const { isOver, connectDragSource, connectDropTarget, moveRow, ...restProps } = this.props;
    const style = { ...restProps.style, cursor: 'move' };

    let { className } = restProps;
    if (isOver) {
      if (restProps.index > dragingIndex) {
        className += ' drop-over-downward';
      }
      if (restProps.index < dragingIndex) {
        className += ' drop-over-upward';
      }
    }

    return connectDragSource(
      connectDropTarget(<tr {...restProps} className={className} style={style} />),
    );
  }
}

const rowSource = {
  beginDrag(props) {
    dragingIndex = props.index;
    return {
      index: props.index,
    };
  },
};

const rowTarget = {
  drop(props, monitor) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Time to actually perform the action
    props.moveRow(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    // eslint-disable-next-line no-param-reassign
    monitor.getItem().index = hoverIndex;
  },
};

const DraggableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
}))(
  DragSource('row', rowSource, connect => ({
    connectDragSource: connect.dragSource(),
  }))(BodyRow),
);

// const DraggableBodyRow = ({ index, moveRow, className, style, ...restProps }) => {
// 	const ref = useRef();
// 	const [{ isOver, dropClassName }, drop] = useDrop({
// 		accept: type,
// 		collect: (monitor) => {
// 			const { dragIndex } = monitor.getItem() || {};
// 			if (dragIndex === index) {
// 				return {};
// 			}
// 			return {
// 				isOver: monitor.isOver(),
// 				dropClassName: dragIndex < index ? ' drop-over-downward' : ' drop-over-upward',
// 			};
// 		},
// 		drop: (item) => {
// 			moveRow(item.dragIndex, index);
// 		},
// 	});
// 	const [, drag] = useDrag({
// 		item: { type, dragIndex: index },
// 		collect: (monitor) => ({
// 			isDragging: monitor.isDragging(),
// 		}),
// 	});
// 	drop(drag(ref));
// 	return (
// 		<tr
// 			ref={ref}
// 			className={`${className}${isOver ? dropClassName : ''}`}
// 			style={{ cursor: 'move', ...style }}
// 			{...restProps}
// 		/>
// 	);
// };

export default DraggableBodyRow;


